module.exports = __webpack_public_path__ + "img/branding-logo-huisstijl-ivoor-brillenmerk-verpakking-4.0ee86ee7.jpg";